import { section_links as links } from 'root/data/section_links';
import GrayButton from 'ui/GrayButton/GrayButton';
import Icon from 'ui/Icon/Icon';
import ListIcon from 'ui/SVG/ListIcon';
import './Sitemap.scss';
import './SitemapAnim.scss';
import SitemapBtn from './Sitemap_partials/SitemapBtn';

import { ControllerContext } from 'components/Controller/Controller';
import { getMouseCoords } from 'root/animator'
import { useRef, useEffect, useContext } from 'react'
import { setToRender, removeFromRender } from 'root/animator';
import { Lerp } from 'root/animator/tween/easing';
import { screens } from '../constants';

require('./star.png')

const currentPosition = {
  x: 0,
  y: 0
}

const Sitemap = () => {
  const { dispatchActive } = useContext(ControllerContext)

  const container = useRef()
  useEffect(() => {
    const label = "sitemap"
    setToRender({
      label,
      handler: () => controller(),
      delay: 10
    })
    return () => removeFromRender(label)
  }, [])
  // todo: оптимизировать, чтобы не рендерить пока не отображается
  function controller() {
    const dom: HTMLElement = container.current
    if (!dom) { return }
    let { x, y } = getMouseCoords().window
    if (x === null || y === null) { return }
    x = ( x - window.innerWidth / 2 )
    y = ( y - window.innerHeight / 2 )
    currentPosition.x = Lerp(currentPosition.x, x, 0.1)
    currentPosition.y = Lerp(currentPosition.y, y, 0.1)
    dom.style.cssText = `transform: translate(${currentPosition.x / -10}px, ${currentPosition.y / -10}px)`
  }

  return (
    <div className="sitemap section" id="sitemap">
      <div className="container sitemap__container">
        <div ref={container} className="sitemap__content">
          <div className="sitemap__row sitemap__row_1">
            <SitemapBtn 
              onClick={() => dispatchActive(screens.ROADMAP)}
              className='sitemap-link --roadmap'
              icon={links[screens.ROADMAP][0]}
              title="Roadmap"
            />
          </div>
          <div className="sitemap__row sitemap__row_2">
            <SitemapBtn 
              onClick={() => dispatchActive(screens.PARTNERS)}
              className='sitemap-link --partners'
              icon={links[screens.PARTNERS][0]}
              title="Partners"
            />
            <SitemapBtn 
              onClick={() => dispatchActive(screens.PRODUCT)}
              className='sitemap-link --product'
              icon={links[screens.PRODUCT][0]}
              title="Product"
            />
          </div>
          <div className="sitemap__row sitemap__row_3">
            <SitemapBtn 
              onClick={() => dispatchActive(screens.INVESTORS)}
              className='sitemap-link --investors'
              icon={links[screens.INVESTORS][0]}
              title="Investors"
            />
            <SitemapBtn 
              onClick={() => dispatchActive(screens.SOCIAL)}
              className='sitemap-link --social'
              icon={links[screens.SOCIAL][0]}
              title="Social"
            />
            </div>
        </div>
        <GrayButton className='sitemap__join'>
          <Icon className='sitemap__join-icon'>
            <ListIcon />
          </Icon>
          <span>Go to App</span>
        </GrayButton>
      </div>
    </div>
  );
};

export default Sitemap;
